import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private _visible$ = new Subject<boolean>();
  private _visible = false;

  get visible$(): Observable<boolean> {
    return this._visible$.asObservable();
  }

  get visible(): boolean {
    return this._visible;
  }

  set visible (value){
    this._visible = value;
    this._visible$.next(value);
  }

  constructor() { }

}
